export const idsToString = (ids: string[]) => {
  const idsString = ids.map((id) => `"${id}"`).join(',')
  return `[${idsString}]`
}
